module.exports = {"id":"211327","name":"Mauro Goicoechea","rating":"72","photo":"./data/images/photos/1/211327.png","club":{"name":"Toulouse FC","logo":"./data/images/clubs/ToulouseFC.png"},"positions":["G"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/MauroGoicoechea0.json
// module id = 2928
// module chunks = 0